import { render, staticRenderFns } from "./projectStudy.vue?vue&type=template&id=3baf0336&"
import script from "./projectStudy.vue?vue&type=script&lang=js&"
export * from "./projectStudy.vue?vue&type=script&lang=js&"
import style0 from "./projectStudy.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports